import React from 'react';
import { Link } from 'react-router-dom';
import { useAdminData } from '../../contexts/AdminDataContext';
import { CONTACT_EMAIL, SERVICE_AREA, company } from '../../data/site';
import { telHref } from '../../utils/format';
export function Footer() {
  const {
    settings
  } = useAdminData();
  return <footer className="border-t border-line bg-canvas-deep" data-id="element-386" data-mp="31eia9w5mqh64">
      <div className="mx-auto max-w-content px-5 py-12 lg:px-8" data-id="element-387" data-mp="31gv1kzxa23vu">
        <div className="flex flex-col gap-10 md:flex-row md:justify-between" data-id="element-388" data-mp="3p5xfbwosjcl2">
          <div data-id="element-389" data-mp="3u3yzym1v7jyn">
            <img src={company.logoWide} alt={settings.companyName} className="h-12 w-auto md:h-14" data-id="element-390" data-mp="3u2e5sxjgq31b" />
            <p className="mt-4 text-[15px] text-ink-soft" data-id="element-391" data-mp="3fe044pxs8kmc">{settings.tagline}</p>
            <p className="mt-2 text-[15px] text-ink-soft" data-id="element-392" data-mp="3kd4evl0cuqes">
              Praktiske opgaver for dig i {SERVICE_AREA}
            </p>
            <p className="mt-4 text-sm text-ink-muted" data-id="element-393" data-mp="bwrnuaipdstq">CVR: {settings.cvr}</p>
          </div>

          <div className="flex flex-col gap-2 text-[15px] md:items-end" data-id="element-394" data-mp="gqdqd9v5kgbt">
            {settings.phone && <a href={telHref(settings.phone)} className="text-ink transition-colors duration-200 ease-smooth hover:text-accent" data-id="element-395" data-mp="3jfuh4knspx7q">
                {settings.phone}
              </a>}
            <a href={`mailto:${CONTACT_EMAIL}`} className="text-ink transition-colors duration-200 ease-smooth hover:text-accent" data-id="element-396" data-mp="3nhfz2kf6t1os">
              {CONTACT_EMAIL}
            </a>
            <div className="mt-3 flex gap-5 text-sm text-ink-muted" data-id="element-397" data-mp="12emhljzoy7r">
              <a href="#kontakt" className="transition-colors duration-200 ease-smooth hover:text-ink" data-id="element-398" data-mp="f1eaqs3lbb3e">
                Kontakt
              </a>
              <a href="#privatliv" className="transition-colors duration-200 ease-smooth hover:text-ink" data-id="element-399" data-mp="b142f8sbs8ld">
                Privatlivspolitik
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-wrap items-center justify-between gap-3 border-t border-line pt-6 text-sm text-ink-muted" data-id="element-400" data-mp="2csqm0p9w117t">
          <p data-id="element-401" data-mp="fsw7rd2qe53h">
            © {new Date().getFullYear()} {settings.companyName}
          </p>
          <Link to="/admin/login" className="transition-colors duration-200 ease-smooth hover:text-ink" data-id="element-402" data-mp="krpaqbke6dpe">
            Admin
          </Link>
        </div>
      </div>
    </footer>;
}